module.exports = __webpack_public_path__ + "static/media/whatsapp-active.d3c6752e.svg";